import { CommonModule, Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-success-alert',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './success-alert.component.html',
  styleUrl: './success-alert.component.css',
  animations: [
    trigger('fadeAnimation', [
      state('void', style({ opacity: 0, transform: 'translateY(20px)' })),
      transition(':enter, :leave', [
        animate('0.3s ease-out')
      ])
    ])
  ]
})
export class SuccessAlertComponent {

  @Input() user = ''
  @Input() message1 = ''
  @Input() message2 = ''

  isVisible: boolean = false;

  showAlert() {
    this.isVisible = true;
  }
  hideAlert() {
    location.reload()
    this.isVisible = false;
  }
}
